import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Footer from "../../CustomComponents/Footer/Footer.jsx";
import PageMetaData from "../../CustomComponents/PageMetaData/PageMetaData.jsx";
import OgMetaTitles from "../../CustomComponents/PageMetaData/OgMetaTitles.jsx";
import CustomSearchFormTransport from "../../CustomComponents/SearchForm/CustomSearchFormActivities/CustomSearchFormTransport.jsx";
import Header from "../../CustomComponents/Header/Header.jsx";
import imgNotFound from "../../assets/images/single-image.png";
import Testimonial from "../../CustomComponents/Testimonial/Testimonial.jsx";
import Highlights from "../../CustomComponents/Highlights/Highlights.jsx";
import FilterActivities from "../../CustomComponents/FilterSection/FilterActivities.jsx";
import { formatIndianCurrency, scrollToTop } from "../../utils/utils.js";
import FilterTransport from "../../CustomComponents/FilterSection/FilterTransport.jsx";
import "./Transport.css";
import ListingTransportSearchForm from "../../CustomComponents/SearchForm/CustomSearchFormActivities/ListingTransportSearchForm.jsx";
import CustomPagination from "../../CustomComponents/CustomPagination/CustomPagination.jsx";
import NoDataFound from "../../CustomComponents/NoDataFound/NoDataFound.jsx";
import Loader from "../../CustomComponents/Loader/Loader.jsx";
import EditNewUiSearchFormTransport from "../../CustomComponents/NewComponents/NewUiSearchForm/NewUiSearchFormTransport/EditNewUiSearchFormTransport.jsx";
import styles from "../../CustomComponents/NewComponents/NewUiTransport/TransportCard.module.scss";
import NewUiHeader from "../../CustomComponents/NewComponents/NewUIHeader/NewUIHeader.jsx";
import NewFooterUI from "../../CustomComponents/NewComponents/NewFooterUI/NewFooterUI.jsx";

function ListingTransportItinerary() {
  const [footerDestinations, setFooterDestinations] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [packageData, setPackageData] = useState([]);

  const [startDestination, setStartDestination] = useState("");
  const [endDestination, setEndDestination] = useState("");
  const [noOfDays, setNoOfDays] = useState(null);
  const [date, setDate] = useState(new Date());

  const { includingDestinations } = location?.state || {};
  const [loader, setLoader] = useState(false);
  const [bookingData, setBookingData] = useState({});

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const data = {
      adult: params.get("adult"),
      date: params.get("date"),
      year: params.get("year"),
      month: params.get("month"),
      noOfDays: params.get("noOfDays"),
      startDestination: params.get("startdestination"),
    };

    const travelDate = `${data.year}-${String(data.month).padStart(
      2,
      "0"
    )}-${String(data.date).padStart(2, "0")}`;
    setBookingData({ ...data, travelDate });
    fetchPackageData(data);

    setDate(travelDate);
    setNoOfDays(data?.noOfDays);
    setStartDestination(data?.startDestination);
    // setEndDestination(data?.endDestination);
  }, [location.search]);

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const clearSelection = () => {
    // console.log("Clearing selection...");
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  
  const displayedData =
    packageData && packageData && packageData.length > 0
      ? packageData.slice(startIndex, endIndex)
      : [];
  const [packageRates, setPackageRates] = useState({});

  // const fetchPackageData = async (data, filters) => {
  //   setLoader(true);
  //   const myHeaders = new Headers();
  //   myHeaders.append("Accept", "application/json");
  //   myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
  //   const formdata = new FormData();
  //   // {
  //   //   data.startDestination &&
  //   //     formdata.append("location", data.startDestination ? data.startDestination : "Shimla");
  //   // }
  //   // includingDestinations.forEach((destination, index) => {
  //   //   formdata.append(`location[${index}]`, destination);
  //   // });

  //   // formdata.append("type", 'transport')

  //   const raw = JSON.stringify({
  //     "hub": startDestination,
  //     "destination": includingDestinations,
  //     "days": Number(noOfDays)
  //   });

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow",
  //   };

  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BASE_URL}/api/v1/transport-holidays/fetch`,
  //       requestOptions
  //     );
  //     if (!response.ok) {
  //       throw new Error(`Error: ${response.statusText}`);
  //     }
  //     const result = await response.json();
  //     setLoader(false);
  //     setPackageData(result.data);

  //     // const rates = {};
  //     // for (const pkg of result.data) {
  //     //   const rateData = await getRatesFromApi(
  //     //     pkg.packageHub,
  //     //     pkg.packageDestination,
  //     //     pkg.totalDays,
  //     //     pkg.totalNights,
  //     //     "sedan"
  //     //   );
  //     //   rates[pkg.id] = rateData;
  //     // }
  //     // setPackageRates(rates);

  //     scrollToTop();
  //   } catch (error) {
  //     setPackageData([]);
  //     scrollToTop();
  //     setLoader(false);
  //     console.error(error);
  //   } finally {
  //     scrollToTop();
  //     setLoader(false);
  //   }
  // };

  const fetchPackageData = async (data) => {
    setLoader(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/transport-holidays/fetch`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            key: process.env.REACT_APP_BASE_API_KEY,
            Cookie: process.env.REACT_APP_COOKIE,
          },
          body: JSON.stringify({
            hub: data?.startDestination?.replace(/^Ex\s+/i, "").trim(),
            destination: includingDestinations,
            days: data?.noOfDays ? Number(data?.noOfDays) : 0,
          }),
          redirect: "follow",
        }
      );

      const result = await response.json();
      setPackageData(result.data);
      setLoader(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    }
  };

  const getRatesFromApi = async (
    packageHub,
    packageDestination,
    totalDays,
    totalNights,
    selectedVehicle
  ) => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const destinationNames = packageDestination?.map((dest) => dest.name);

    const formdata = new FormData();
    formdata.append("hub", packageHub);
    destinationNames?.forEach((name) => {
      formdata.append("destinations[]", name);
    });
    formdata.append("days", totalDays);
    formdata.append("nights", totalNights);
    formdata.append("vehicle_type", selectedVehicle);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/transport-fixed-rates/fetch`,
        requestOptions
      );
      const result = await response.json();
      return result?.data[0];
    } catch (error) {
      console.error("Error:", error);
      return null;
    }
  };

  const sendDataToParent = (data) => {
    if (data.destinationType.length > 0) {
      // fetchPackageData(bookingData, data);
    }
  };

  const navigateToSingleTransport = (item) => {
    navigate(
      `/transport/${item.packagehandle}?packageId=${
        item?.packageId
      }&startdestination=${startDestination}&noOfDays=${noOfDays}&date=${new Date(
        date
      ).getDate()}&month=${new Date(date).getMonth() + 1}&year=${new Date(
        date
      ).getFullYear()}`,
      {
        state: {
          transportData: item,
          bookingData: bookingData,
          // activityPrice: displayedRate,
          // selectedAddOns: selectedAddOns,
          // totalAddonsCost: totalAddonsCost,
          // totalAddonsCostWithoutCommission: totalAddonsCostWithoutCommission,
          // markupData: markupData,
          // activityPriceWithMarkup, activityPriceWithMarkup,
        },
      }
    );
  };

  const [markupData, setMarkupData] = useState(null);

  const fetchMarkup = async () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/markups`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          const findObject = result?.data?.find(
            (mark) => mark?.markupCustomer === "both"
          );
          setMarkupData(findObject || null);
        } else {
          setMarkupData("No data found");
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    fetchMarkup();
  }, []);

  const calculatePriceWithMarkup = (basePrice) => {
    if (!markupData) return basePrice;

    const { markupType, amount } = markupData;

    if (markupType === "percentage") {
      const percentageAmount = (parseFloat(amount) / 100) * basePrice;
      return basePrice + percentageAmount;
    }

    if (markupType === "fixed") {
      return basePrice + parseFloat(amount);
    }

    return basePrice; // Default fallback
  };

  return (
    <div id="transport">
      <PageMetaData
        title="Transport Package Listing"
        // description="Book hotels in Himachal Pradesh at the best budget tariffs. Explore our curated list of luxury and budget hotels with the best available prices. Compare rates and find the perfect stay with us!"
        // keywords="Hotels In Himachal Pradesh"
      />
      {/* 

      <OgMetaTitles
        title="The Best Hotels in Himachal Pradesh, India -  Mountain Mysteries"
        type="Book hotels in Himachal Pradesh at the best budget tariffs. Explore our curated list of luxury and budget hotels with the best available prices. Compare rates and find the perfect stay with us!"
        url="https://www.mountainmysteries.com/accommodation/"
      /> */}

      <NewUiHeader />
      {/* <Header /> */}
      {/* <ListingTransportSearchForm
        includingDestinations={includingDestinations}
      /> */}
      <EditNewUiSearchFormTransport
        includingDestinations={includingDestinations}
      />

      <section className="common_padding new_ui_bg">
        <div className="container">
          {/* <FilterActivities
                        sendDataToParent={sendDataToParent}
                        showDestinations={true}
                    /> */}
          {/* <FilterTransport sendDataToParent={sendDataToParent} /> */}
          <div>
            <div className="flex align_items_center flex_wrap justify_content_center mb-30">
              <h4 className="new_ui_heading "
                style={{ textTransform: "capitalize" }}
              >
                Showing All Transport
              </h4>
            </div>
            <div className="transport_listing_page flex flex_direction_col flex_gap_10">
              <div className="flex flex_gap_20 flex_wrap">
                {loader ? (
                  <Loader size="3em" color="#016937" />
                ) : (
                  <>
                    {displayedData && displayedData.length > 0 ? (
                      <>
                        {displayedData?.map((item, index) => (
                          <div
                            className={styles.package_listing_card}
                            key={index}
                          >
                            <div className={styles.listing_card_data}>
                              {" "}
                              <div className={styles.img_sec}>
                                {item.featuredImage ? (
                                  <img
                                    src={item.featuredImage}
                                    alt={item.packageName}
                                  />
                                ) : (
                                  <img
                                    src={imgNotFound}
                                    alt="Image not found"
                                  />
                                )}
                              </div>
                              <div className={styles.detail_button_align}>
                                <div className={styles.content_sec}>
                                  <h3 className="cursor_pointer">
                                    {item?.packageName}{" "}
                                  </h3>
                                  <div className={styles.location}>
                                    <div>
                                      <svg
                                        width="14"
                                        height="15"
                                        viewBox="0 0 14 15"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <mask
                                          id="mask0_5990_6365"
                                          style={{ maskType: "alpha" }}
                                          maskUnits="userSpaceOnUse"
                                          x="0"
                                          y="0"
                                          width="14"
                                          height="15"
                                        >
                                          <rect
                                            y="0.5"
                                            width="14"
                                            height="14"
                                            fill="#D9D9D9"
                                          />
                                        </mask>
                                        <g mask="url(#mask0_5990_6365)">
                                          <path
                                            d="M9.02596 10.1407L9.64079 9.52584L7.43754 7.32259V4.58325H6.56254V7.67711L9.02596 10.1407ZM7.00106 13.0416C6.23456 13.0416 5.5141 12.8961 4.83967 12.6053C4.16523 12.3144 3.5786 11.9196 3.07975 11.4209C2.5809 10.9223 2.18594 10.3359 1.89485 9.66175C1.60387 8.98761 1.45837 8.26734 1.45837 7.50094C1.45837 6.73444 1.60382 6.01397 1.89471 5.33954C2.1856 4.66511 2.58037 4.07847 3.07902 3.57963C3.57767 3.08078 4.16407 2.68581 4.83821 2.39473C5.51235 2.10374 6.23262 1.95825 6.99902 1.95825C7.76552 1.95825 8.48599 2.1037 9.16042 2.39459C9.83485 2.68547 10.4215 3.08025 10.9203 3.5789C11.4192 4.07755 11.8141 4.66395 12.1052 5.33809C12.3962 6.01222 12.5417 6.73249 12.5417 7.4989C12.5417 8.2654 12.3963 8.98586 12.1054 9.66029C11.8145 10.3347 11.4197 10.9214 10.9211 11.4202C10.4224 11.9191 9.83601 12.314 9.16187 12.6051C8.48774 12.8961 7.76746 13.0416 7.00106 13.0416ZM7.00004 12.1666C8.2931 12.1666 9.39414 11.7121 10.3032 10.803C11.2122 9.89402 11.6667 8.79297 11.6667 7.49992C11.6667 6.20686 11.2122 5.10582 10.3032 4.19679C9.39414 3.28777 8.2931 2.83325 7.00004 2.83325C5.70698 2.83325 4.60594 3.28777 3.69692 4.19679C2.78789 5.10582 2.33337 6.20686 2.33337 7.49992C2.33337 8.79297 2.78789 9.89402 3.69692 10.803C4.60594 11.7121 5.70698 12.1666 7.00004 12.1666Z"
                                            fill="#1C1B1F"
                                          />
                                        </g>
                                      </svg>
                                      {item?.totalNights}N/{item?.totalDays}D
                                    </div>
                                    <div>
                                      <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <mask
                                          id="mask0_5983_7301"
                                          style={{ maskType: "alpha" }}
                                          maskUnits="userSpaceOnUse"
                                          x="0"
                                          y="0"
                                          width="18"
                                          height="18"
                                        >
                                          <rect
                                            width="18"
                                            height="18"
                                            fill="#D9D9D9"
                                          />
                                        </mask>
                                        <g mask="url(#mask0_5983_7301)">
                                          <path
                                            d="M9.0013 8.89894C9.37443 8.89894 9.69343 8.76606 9.9583 8.50031C10.2233 8.23456 10.3558 7.91512 10.3558 7.542C10.3558 7.16887 10.2229 6.84981 9.95718 6.58481C9.69143 6.31994 9.37193 6.1875 8.99868 6.1875C8.62555 6.1875 8.30655 6.32038 8.04168 6.58613C7.77668 6.85188 7.64418 7.17138 7.64418 7.54463C7.64418 7.91775 7.77705 8.23675 8.0428 8.50163C8.30855 8.7665 8.62805 8.89894 9.0013 8.89894ZM8.99999 14.6351C10.4672 13.3216 11.5901 12.0618 12.3684 10.8555C13.1468 9.64925 13.536 8.59275 13.536 7.686C13.536 6.31875 13.1016 5.19475 12.2329 4.314C11.3641 3.43325 10.2865 2.99287 8.99999 2.99287C7.71349 2.99287 6.63586 3.43325 5.76711 4.314C4.89836 5.19475 4.46399 6.31875 4.46399 7.686C4.46399 8.59275 4.85318 9.64925 5.63155 10.8555C6.40993 12.0618 7.53274 13.3216 8.99999 14.6351ZM8.99999 16.1321C7.11249 14.4966 5.69711 12.9746 4.75386 11.5659C3.81061 10.1572 3.33899 8.86387 3.33899 7.686C3.33899 5.95525 3.8988 4.55406 5.01843 3.48244C6.13818 2.41081 7.46536 1.875 8.99999 1.875C10.5346 1.875 11.8618 2.41081 12.9816 3.48244C14.1012 4.55406 14.661 5.95525 14.661 7.686C14.661 8.86387 14.1894 10.1572 13.2461 11.5659C12.3029 12.9746 10.8875 14.4966 8.99999 16.1321Z"
                                            fill="#1C1B1F"
                                          />
                                        </g>
                                      </svg>
                                      {item.packageHub}
                                    </div>
                                  </div>
                                  {/* <div>
                                    <ul>
                                      <div>
                                        {" "}
                                        <li>1N Dharamshala</li>
                                      </div>
                                      <div>
                                        {" "}
                                        <li>2N Kinnour</li>
                                      </div>
                                    </ul>
                                  </div> */}
                                  <div className={styles.plan}>
                                    <div className={`${styles.des_text} text-capitalize`}>
                                      Starts: {item?.startingPrice?.startCity}
                                    </div>
                                    <div className={styles.dots}>
                                      <div className={styles.circle}></div>
                                      <div className={styles.line}> </div>
                                      <div className={styles.circle}></div>
                                    </div>
                                    <div className={`${styles.des_text} text-capitalize`}>
                                      Ends: {item?.startingPrice?.startCity}
                                    </div>
                                  </div>{" "}
                                </div>
                                <div>
                                  <div className={styles.pricing_details}>
                                    {/* <div className={styles.discount_btn}>20% off</div> */}
                                    <div className={styles.price_info}>
                                      <small>
                                        Price for{" "}
                                        <strong className="text-capitalize">
                                          {item?.startingPrice?.vehicleType}
                                        </strong>{" "}
                                        with Partial AC
                                      </small>
                                      <h4>
                                        {formatIndianCurrency(
                                          calculatePriceWithMarkup(
                                            item?.startingPrice?.priceWithoutAC
                                          )
                                        )}
                                      </h4>
                                    </div>
                                  </div>
                                  <button
                                    className={styles.view_btn}
                                    onClick={() =>
                                      navigateToSingleTransport(item)
                                    }
                                  >
                                    {" "}
                                    View Details
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          // <div className="transport_cabs_card" key={index}>
                          //   <div className="transport_card_listing_page_image">
                          //     {item.featuredImage ? (
                          //       <img src={item.featuredImage} alt={item.packageName} />
                          //     ) : (
                          //       <img src={imgNotFound} alt="Image not found" />
                          //     )}
                          //   </div>
                          //   <div className="transport_card_listing_page_content">
                          //     <h2>{item?.packageName}</h2>
                          //     <p>{item?.packageHub}</p>

                          //     <div className="transport_card_destinations flex flex_gap_20 mt-10">
                          //       <div className="transport_card_destinations_child">
                          //         <p>Start City</p>
                          //         <h6 className="text-capitalize">{item?.startingPrice?.startCity}</h6>
                          //       </div>
                          //       <div className="transport_card_dashed_line">
                          //         <div className="transport_circle"></div>
                          //         <div className="dashed-line"></div>
                          //         <div className="transport_circle"></div>
                          //       </div>
                          //       <div className="transport_card_destinations_child">
                          //         <p>End City</p>
                          //         <h6 className="text-capitalize">{item?.startingPrice?.endCity}</h6>
                          //       </div>
                          //     </div>
                          //     {/* <div className="transport_options">
                          //   <h5>Transport Options:</h5>
                          //   <div className="flex flex_gap_10 align_items_center">
                          //     <div className="transport_options_cabs">
                          //       SEDAN
                          //     </div>
                          //     <div className="transport_options_cabs">
                          //       MUV
                          //     </div>  <div className="transport_options_cabs">
                          //       CRYSTA
                          //     </div>
                          //     <div className="transport_options_cabs">
                          //       TAMPO
                          //     </div>
                          //     <div className="transport_options_cabs">
                          //       URBANIA
                          //     </div>

                          //     <div className="transport_options_cabs_ac">
                          //       <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
                          //         <path d="M7.30046 7.46674L6.33379 6.51675C6.21157 6.39452 6.05879 6.33341 5.87546 6.33341C5.69212 6.33341 5.53379 6.40008 5.40046 6.53341C5.27823 6.65563 5.21712 6.81119 5.21712 7.00008C5.21712 7.18897 5.27823 7.34452 5.40046 7.46674L6.83379 8.90008C6.96712 9.03341 7.12268 9.10008 7.30046 9.10008C7.47823 9.10008 7.63379 9.03341 7.76712 8.90008L10.6005 6.06675C10.7338 5.93341 10.7977 5.77786 10.7921 5.60008C10.7866 5.4223 10.7227 5.26675 10.6005 5.13341C10.4671 5.00008 10.3088 4.93063 10.1255 4.92508C9.94212 4.91952 9.78379 4.98341 9.65046 5.11675L7.30046 7.46674ZM5.43379 13.5001L4.46712 11.8667L2.63379 11.4667C2.46712 11.4334 2.33379 11.3473 2.23379 11.2084C2.13379 11.0695 2.0949 10.9167 2.11712 10.7501L2.30046 8.86675L1.05046 7.43341C0.939345 7.31119 0.883789 7.16675 0.883789 7.00008C0.883789 6.83341 0.939345 6.68897 1.05046 6.56675L2.30046 5.13341L2.11712 3.25008C2.0949 3.08341 2.13379 2.93063 2.23379 2.79175C2.33379 2.65286 2.46712 2.56675 2.63379 2.53341L4.46712 2.13341L5.43379 0.500079C5.52268 0.355635 5.6449 0.258412 5.80046 0.208412C5.95601 0.158412 6.11157 0.166746 6.26712 0.233412L8.00046 0.966746L9.73379 0.233412C9.88935 0.166746 10.0449 0.158412 10.2005 0.208412C10.356 0.258412 10.4782 0.355635 10.5671 0.500079L11.5338 2.13341L13.3671 2.53341C13.5338 2.56675 13.6671 2.65286 13.7671 2.79175C13.8671 2.93063 13.906 3.08341 13.8838 3.25008L13.7005 5.13341L14.9505 6.56675C15.0616 6.68897 15.1171 6.83341 15.1171 7.00008C15.1171 7.16675 15.0616 7.31119 14.9505 7.43341L13.7005 8.86675L13.8838 10.7501C13.906 10.9167 13.8671 11.0695 13.7671 11.2084C13.6671 11.3473 13.5338 11.4334 13.3671 11.4667L11.5338 11.8667L10.5671 13.5001C10.4782 13.6445 10.356 13.7417 10.2005 13.7917C10.0449 13.8417 9.88935 13.8334 9.73379 13.7667L8.00046 13.0334L6.26712 13.7667C6.11157 13.8334 5.95601 13.8417 5.80046 13.7917C5.6449 13.7417 5.52268 13.6445 5.43379 13.5001ZM6.30046 12.3001L8.00046 11.5667L9.73379 12.3001L10.6671 10.7001L12.5005 10.2667L12.3338 8.40008L13.5671 7.00008L12.3338 5.56675L12.5005 3.70008L10.6671 3.30008L9.70046 1.70008L8.00046 2.43341L6.26712 1.70008L5.33379 3.30008L3.50046 3.70008L3.66712 5.56675L2.43379 7.00008L3.66712 8.40008L3.50046 10.3001L5.33379 10.7001L6.30046 12.3001Z" fill="#009A50" />
                          //       </svg>
                          //       AC Facility
                          //     </div>
                          //   </div>
                          // </div> */}
                          //   </div>
                          //   <div className="transport_card_listing_page_price">
                          //     <span className="font_11">Price for <strong className="text-capitalize">{item?.startingPrice?.vehicleType}</strong> with Partial AC</span>
                          //     <h5>
                          //       {/* {
                          //     formatIndianCurrency(item?.startingPrice?.priceWithoutAC)} {'   '} */}
                          //       {formatIndianCurrency(calculatePriceWithMarkup(item?.startingPrice?.priceWithoutAC))}</h5>
                          //     <span className="font_11">+ GST (%)</span>
                          //     <div className="flex justify_content_end">
                          //       <button
                          //         onClick={() => navigateToSingleTransport(item)}
                          //         style={{ width: 'auto', marginTop: '10px' }}
                          //         className="primary_btn w-auto">
                          //         View Details
                          //       </button>
                          //     </div>
                          //   </div>
                          // </div>
                        ))}
                      </>
                    ) : (
                      <h4>No Data Found</h4>
                    )}
                  </>
                )}
              </div>

              {displayedData && displayedData.length > 0 && (
                <div className="communication_pagination">
                  <CustomPagination
                    currentPage={currentPage}
                    itemsPerPage={itemsPerPage}
                    totalItems={packageData?.length}
                    onPageChange={handlePageChange}
                    clearSelection={clearSelection}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <NewFooterUI />
      {/* <Footer /> */}
    </div>
  );
}

export default ListingTransportItinerary;
